import React from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import PropTypes from 'prop-types'

const TeamGridComponent = ({ data, className }) => {

  const team = data.map((data, index) => {
    return (
      <div className="team-member" key={index}>
        {data.image &&
          <img 
            src={ 
              data.image.childImageSharp
              ? data.image.childImageSharp.fluid.src
              : data.image
            }
           />
        }
        <div>
          <strong>{data.name}</strong>
          <p>{data.bio}</p>
        </div>
      </div>
    );

  });

  return (
    <div className={className}>
      {team}
    </div>
  )
}

TeamGridComponent.propTypes = {
  className: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired
}
  
const TeamGrid = styled(TeamGridComponent)`
  ${tw``}
  margin-top: 60px;
  .team-member {
    padding: 0 32px 40px 0;
    display: flex;
    img {
      object-fit: cover;
      object-position: center top;
      width: 120px;
      height: 120px;
      border-radius: 50%;
      box-shadow: 0 8px 0 0 #000;
      filter: grayscale(1);

      @media (max-width: 649px) {
        width: 80px;
        height: 80px;
      }
      @media (max-width: 479px) {
        width: 60px;
        height: 60px;
      }
    }
    div {
      padding-left: 20px;
      @media (max-width: 649px) {
        font-size: 0.8rem;
      }
    }
  }
`

export default TeamGrid
